import CircularProgress from "@material-ui/core/CircularProgress";
import React, { FC, useEffect, useRef, useState } from "react";
import { styled } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CampaignTemplate } from "../../types/campaignTypes";
import { ROUTE_PATHS } from "../../types/RoutePaths";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";
import { initializeGlobalAdvertiser } from "../../redux/reducers/agency";
import { initializeStateWithTemplateData } from "../../utils/initializeStateWithTemplateData";

const LoaderWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: 300,
});

const CampaignTemplateEditPageRedesign: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<{ template?: CampaignTemplate }>();
  const advertisers = useSelector((state: ReduxApplicationState) => state.agency.advertisers);

  const [isReady, setIsReady] = useState(false);
  const hasFetched = useRef(false);

  const template = location.state?.template;

  useEffect(() => {
    if (!template) {
      history.replace(ROUTE_PATHS.CAMPAIGN_TEMPLATES);
      return;
    }
    if (!hasFetched.current) {
      hasFetched.current = true;
      const init = async () => {
        await initializeStateWithTemplateData(template, dispatch, advertisers);
        dispatch(initializeGlobalAdvertiser());
        setIsReady(true);
      };
      init();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!template) return null;

  if (!isReady) {
    return (
      <LoaderWrapper>
        <CircularProgress style={{ color: "#F06449" }} />
      </LoaderWrapper>
    );
  }

  const handleBack = () => history.push(ROUTE_PATHS.CAMPAIGN_TEMPLATES);

  return <CampaignBuilderForm mode="template" skipInitialReset isEditMode onBack={handleBack} onSuccess={handleBack} />;
};

export default CampaignTemplateEditPageRedesign;
